import { xRescale } from 'ml-spectra-processing';
/**
 * Center the mean
 * @param data
 * @param options
 */
export function rescale(data, options = {}) {
    xRescale(data.y, { ...options, output: data.y });
    return { data };
}
//# sourceMappingURL=rescale.js.map